/**
 * Есть ли сеть у устройства (Capacitor Network или fallback на navigator.onLine).
 */
export async function isNetworkConnected(): Promise<boolean> {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return false;
  }
  try {
    const { Network } = await import('@capacitor/network');
    const s = await Network.getStatus();
    return s.connected;
  } catch {
    return typeof navigator === 'undefined' ? true : navigator.onLine;
  }
}
